export enum PathName {
  HOME = "/home",
  CATALOG = "/catalog/products",
  ANALYTICS = "/analytics",
  STORE_ONBOARDING = "/store-onboarding",
  STORE_POLICIES = "/store-policies",
  OMS = "/orders",
  PROFILE = "/profile",
  STORE_TIMINGS = "/store-timings",
  DELIVERY_SETTINGS = "/delivery-settings",
  PAYMENTS = "/payments",
  STORE_APPEARANCE = "/store-appearance",
  OFFERS = "/offers",
  RETURNS = "/returns/config",
  ORDER_RETURNS = "/returns",
  CUSTOMER_SEGMENTS = "customer-segments",
  PREPAID_OFFERS = "prepaid-offers",
  CUSTOM_DOMAIN = "custom-domain",
  SETUP_CUSTOM_DOMAIN = "setup-custom-domain",
  SETTINGS = "settings",
  SETTINGS_REVIEWS = "/settings/reviews",
  SOCIAL_MEDIA = "social-media",
  MANAGE = "/manage",
  GST_SELLER = "gst-seller",
  REVIEWS_MANAGE = "/reviews/manage",
  CONNECTIONS = "connections"
}
